"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHADES = exports.REMOVE = exports.RATING = exports.QUICK_BUY = exports.PRODUCT_BOX_SKELETON = exports.NOTIFY_ME = exports.NOTIFICATION_FILLED = exports.NOTIFICATION = exports.LOADING = exports.IMG = exports.FAVORITE = exports.ALT_IMG = void 0;
/* istanbul ignore file */
const LOADING = exports.LOADING = 'loading';
const FAVORITE = exports.FAVORITE = 'favorite';
const NOTIFY_ME = exports.NOTIFY_ME = 'notifyMe';
const REMOVE = exports.REMOVE = 'remove';
const NOTIFICATION = exports.NOTIFICATION = 'notification';
const NOTIFICATION_FILLED = exports.NOTIFICATION_FILLED = 'notificationFilled';
const IMG = exports.IMG = 'img';
const ALT_IMG = exports.ALT_IMG = 'alt-img';
const RATING = exports.RATING = 'rating';
const SHADES = exports.SHADES = 'shades';
const QUICK_BUY = exports.QUICK_BUY = 'quick-buy';
const PRODUCT_BOX_SKELETON = exports.PRODUCT_BOX_SKELETON = 'product-box-skeleton';
//# sourceMappingURL=testIds.js.map